/** Normalise le rôle API (ex. ADMIN → admin) pour les contrôles d’accès. */
export function normalizeRole(role: string | undefined | null): string {
  return String(role ?? "")
    .trim()
    .toLowerCase();
}

/** Rôles autorisés pour Factures, Paiements, Recouvrement (aligné AuthContext). */
export const FINANCE_MODULE_ROLES = ["admin", "finance", "recouvrement"] as const;

export function canAccessFinanceModule(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return (FINANCE_MODULE_ROLES as readonly string[]).includes(r);
}

/** Validation / refus proforma (simulation admin / finance). */
export function canValidateProformaClient(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return ["admin", "finance"].includes(r);
}

/** Envoi proforma au client (cycle ENVOYEE). */
export function canSendProforma(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return ["admin", "finance", "recouvrement"].includes(r);
}

/** Création passage exceptionnel depuis proforma terrain. */
export function canCreatePassageFromProforma(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return ["admin", "planificateur", "superviseur"].includes(r);
}

/** Conversion proforma → facture. */
export function canConvertProformaToFacture(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return ["admin", "finance"].includes(r);
}

/** Annulation facture (API réservée ADMIN / FINANCE). */
export function canCancelFacture(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return ["admin", "finance"].includes(r);
}

type RouteUserLike = {
  role?: string | null;
};

/** Route par défaut post-login et guards (centralisée). */
export function getDefaultRouteForUser(user: RouteUserLike | null | undefined): string {
  const role = normalizeRole(user?.role);

  if (
    role === "agent" ||
    role === "agent_terrain" ||
    role === "terrain" ||
    role === "chauffeur"
  ) {
    return "/ag/me/dashboard";
  }
  if (role === "client") {
    return "/client/me/dashboard";
  }
  if (role === "planificateur") {
    return "/admin/planificateur/tournees";
  }
  if (role === "superviseur") {
    return "/admin/dashboard";
  }
  if (role === "finance") {
    return "/admin/dashboard";
  }
  if (role === "admin" || role === "super_admin") {
    return "/admin/dashboard";
  }

  return "/admin/dashboard";
}
